import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-progress-circle-graph',
  templateUrl: './progress-circle-graph.component.html',
  styleUrls: ['./progress-circle-graph.component.scss']
})
export class ProgressCircleGraphComponent {
  @Input() graphSize: number | undefined;
  @Input() progress: number | undefined;
  @Input() contentInCenterFirstElement: string;
  @Input() contentInCenterSecondElement: string;
  @Input() defaultColor: boolean;
}
